import React, { Component } from 'react';
import apiDown from '../assets/Images/api-down.png';

class InternalServerError extends Component {

  render() {
    return (
      <div className="main-content">
        <div className="ccpa-wrapper">
          <div className="component-section">
            <div className ="max-width-22 position-center margin-center">
              <img src={apiDown} className="margin-bottom-2 position-center" alt="api-down" /> 
              <p className="margin-top-1 font-size-14 text-bold">
                We are extremely sorry! We are experiencing some technical difficulties on our side. Please try your request again later.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default InternalServerError;



// WEBPACK FOOTER //
// src/components/InternalServerError.js